const FormResources = {

    form_data:{
        cost_center_department_id: '',
        position_id: '',
        associate_id:'',
        report_associate_id: '',
        contract_type_id: '',
        associate_number: '',
        first_name: '',
        last_name: '',
        birth_date: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip_code: '',
        phone1: '',
        phone2: '',
        emergency_phone: '',
        email: '',
        shift: 1,
        hire_date: '',
        hourly_pay: '',
        pager_number: '',
        hours: '',
        next_evaluation: '',
        department_hire_date: '',
        comments: '',
        is_supervisor: false,
        status: true,
        role_id: '',
        permissions_template_id: '',
        include_in_supervisor_lists: false,
        give_access_to: []
    },

    form_main_format: 
        [
            {
                css_class:  'col-md-6',
                type:       'text',
                maxlength:  45,
                disabled:   false,
                step:       '',
                name:       'First Name:',
                model_name: 'first_name',
                ref:        'first_name_input',
                ref_alt:    'first_name_input_alt',
                required:   true,
            },
            {
                css_class:  'col-md-6',
                type:       'text',
                maxlength:  45,
                disabled:   false,
                step:       '',
                name:       'Last name:',
                model_name: 'last_name',
                ref:        'last_name_input',
                ref_alt:    'last_name_input_alt',
                required:   true,
            },
            {
                css_class:  'col-md-6',
                type:       'textarea',
                maxlength:  245,
                disabled:   false,
                step:       '',
                name:       'Address 1:',
                model_name: 'address1',
                ref:        'address1_input',
                ref_alt:    'address1_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'textarea',
                maxlength:  245,
                disabled:   false,
                step:       '',
                name:       'Address 2:',
                model_name: 'address2',
                ref:        'address2_input',
                ref_alt:    'address2_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'text',
                maxlength:  100,
                disabled:   false,
                step:       '',
                name:       'City:',
                model_name: 'city',
                ref:        'city_input',
                ref_alt:    'city_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'text',
                maxlength:  100,
                disabled:   false,
                step:       '',
                name:       'State:',
                model_name: 'state',
                ref:        'state_input',
                ref_alt:    'state_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'select',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Role:',
                model_name: 'role_id',
                ref:        'role_id_input',
                ref_alt:    'role_id_input_alt',
                required:   true,
            },
            {
                css_class:  'col-md-6',
                type:       'select',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Permissions Template:',
                model_name: 'permissions_template_id',
                ref:        'permissions_template_id_ref',
                ref_alt:    'permissions_template_id_ref_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'infinite-scroll-list',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Give Access to:',
                model_name: 'give_access_to',
                ref:        'give_access_to_input',
                ref_alt:    'give_access_to_input_alt',
                required:   false,
                search: false,
                parent_class: 'custom-control custom-checkbox w-100',
                input_type: 'checkbox',
                input_class: 'custom-control-input',
                label_input_class: 'custom-control-label reports__show-hide__label ml-2',
                placeholder: 'Select facilities',
                close_on_option: false,
                track_by: 'name'
            },
            {
                css_class:  'col-md-6',
                type:       'text',
                maxlength:  15,
                disabled:   false,
                step:       '',
                name:       'Zip code:',
                model_name: 'zip_code',
                ref:        'zip_code_input',
                ref_alt:    'zip_code_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-12',
                type:       'select',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Reports to:',
                model_name: 'report_associate_id',
                ref:        'report_id_input',
                ref_alt:    'report_id_input_alt',
                required:   true,
            },
            {
                css_class:  'col-md-6',
                type:       'tel',
                maxlength:  15,
                disabled:   false,
                step:       '',
                name:       'Phone 1:',
                model_name: 'phone1',
                ref:        'phone1_input',
                ref_alt:    'phone1_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'tel',
                maxlength:  15,
                disabled:   false,
                step:       '',
                name:       'Phone 2:',
                model_name: 'phone2',
                ref:        'phone2_input',
                ref_alt:    'phone2_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'text',
                maxlength:  15,
                disabled:   false,
                step:       '',
                name:       'Emergency phone:',
                model_name: 'emergency_phone',
                ref:        'emergency_phone_input',
                ref_alt:    'emergency_phone_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'text',
                maxlength:  100,
                disabled:   false,
                step:       '',
                name:       'Email:',
                model_name: 'email',
                ref:        'email_input',
                ref_alt:    'email_input_alt',
                required:   true,
            },
            {
                css_class:  'col-md-6',
                type:       'date',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Birth date:',
                model_name: 'birth_date',
                ref:        'birth_date_input',
                ref_alt:    'birth_date_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'text',
                maxlength:  30,
                disabled:   false,
                step:       '',
                name:       'Pager number:',
                model_name: 'pager_number',
                ref:        'pager_number_input',
                ref_alt:    'pager_number_input_alt',
                required:   false,
            },
            // {
            //     css_class:  'col-md-4',
            //     type:       'switch',
            //     maxlength:  '',
            //     disabled:   false,
            //     step:       '',
            //     name:       'Supervisor:',
            //     model_name: 'is_supervisor',
            //     ref:        'is_supervisor_input',
            //     ref_alt:    'is_supervisor_input_alt',
            //     required:   false,
            // },
            {
                css_class:  'col-md-6',
                type:       'switch',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Active:',
                model_name: 'status',
                ref:        'status_input',
                ref_alt:    'status_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'checkbox',
                maxlength:  100,
                disabled:   false,
                step:       '',
                name:       'Include in supervisor lists:',
                model_name: 'include_in_supervisor_lists',
                ref:        'include_in_supervisor_lists_ref',
                ref_alt:    'include_in_supervisor_lists_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'number',
                maxlength:  '',
                disabled:   false,
                step:       'any',
                name:       'Hours:',
                model_name: 'hours',
                ref:        'hours_input',
                ref_alt:    'hours_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'number',
                maxlength:  '',
                disabled:   false,
                step:       'any',
                name:       'Associate ID:',
                model_name: 'associate_number',
                ref:        'associate_number_input',
                ref_alt:    'associate_number_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'date',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Hire date:',
                model_name: 'hire_date',
                ref:        'hire_date_input',
                ref_alt:    'hire_date_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'date',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Next evaluation:',
                model_name: 'next_evaluation',
                ref:        'next_evaluation_input',
                ref_alt:    'next_evaluation_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'number',
                maxlength:  '',
                disabled:   false,
                step:       'any',
                name:       'Hourly pay:',
                model_name: 'hourly_pay',
                ref:        'hourly_pay_input',
                ref_alt:    'hourly_pay_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'select',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Position:',
                model_name: 'position_id',
                ref:        'position_id_input',
                ref_alt:    'position_id_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'select',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Contact Type:',
                model_name: 'contract_type_id',
                ref:        'contract_type_id_input',
                ref_alt:    'contract_type_id_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'select',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Shift:',
                model_name: 'shift',
                ref:        'shift_input',
                ref_alt:    'shift_input_alt',
                required:  false,
            },
            {
                css_class:  'col-md-6',
                type:       'select',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Department:',
                model_name: 'cost_center_department_id',
                ref:        'cost_center_department_id_input',
                ref_alt:    'cost_center_department_id_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-6',
                type:       'date',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Department date of hire:',
                model_name: 'department_hire_date',
                ref:        'department_hire_date_input',
                ref_alt:    'department_hire_date_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-12',
                type:       'textarea',
                maxlength:  245,
                disabled:   false,
                step:       '',
                name:       'Comments:',
                model_name: 'comments',
                ref:        'comment_input',
                ref_alt:    'comment_input_alt',
                required:   false,
            },
        ]

    ,
    
    form_format_lite:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'First Name:',
            model_name: 'first_name',
            ref:        'first_name_input',
            ref_alt:    'first_name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Last name:',
            model_name: 'last_name',
            ref:        'last_name_input',
            ref_alt:    'last_name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Role:',
            model_name: 'role_id',
            ref:        'role_id_input',
            ref_alt:    'role_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Permissions Template:',
            model_name: 'permissions_template_id',
            ref:        'permissions_template_id_ref',
            ref_alt:    'permissions_template_id_ref_alt',
            required:   false,
        },
    ],
    
    form_format_lite2:[
        {
            css_class:  'col-md-6',
            type:       'tel',
            maxlength:  15,
            disabled:   false,
            step:       '',
            name:       'Phone:',
            model_name: 'phone1',
            ref:        'phone1_input',
            ref_alt:    'phone1_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Email:',
            model_name: 'email',
            ref:        'email_input',
            ref_alt:    'email_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'switch',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Active:',
            model_name: 'status',
            ref:        'status_input',
            ref_alt:    'status_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Include in supervisor lists:',
            model_name: 'include_in_supervisor_lists',
            ref:        'include_in_supervisor_lists_ref',
            ref_alt:    'include_in_supervisor_lists_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift',
            ref:        'shift_input',
            ref_alt:    'shift_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Comments:',
            model_name: 'comments',
            ref:        'comment_input',
            ref_alt:    'comment_input_alt',
            required:   false,
        },
    ],

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'First Name:',
            model_name: 'first_name',
            ref:        'first_name_input',
            ref_alt:    'first_name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Last name:',
            model_name: 'last_name',
            ref:        'last_name_input',
            ref_alt:    'last_name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Address 1:',
            model_name: 'address1',
            ref:        'address1_input',
            ref_alt:    'address1_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Address 2:',
            model_name: 'address2',
            ref:        'address2_input',
            ref_alt:    'address2_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'City:',
            model_name: 'city',
            ref:        'city_input',
            ref_alt:    'city_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'State:',
            model_name: 'state',
            ref:        'state_input',
            ref_alt:    'state_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Role:',
            model_name: 'role_id',
            ref:        'role_id_input',
            ref_alt:    'role_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  15,
            disabled:   false,
            step:       '',
            name:       'Zip code:',
            model_name: 'zip_code',
            ref:        'zip_code_input',
            ref_alt:    'zip_code_input_alt',
            required:   false,
        },
    ],

    shift_options:  [
        {
            id:     1,
            name:   'Day',
        },
        {
            id:     2,
            name:   'Evening',
        },
        {
            id:     3,
            name:   'Night',
        },
    ],

}

export default FormResources;